const REQUIRED_LENGTH = 9;
const ALLOWED_CHARACTERS = /^[0-9-]+$/;
const SUPPORTED_FORMAT = /^\d{9}$|^\d{3}-\d{2}-\d{4}$/;

export const SSN_ERROR_MESSAGES = {
    characters: 'SSN can only contain digits and dashes.',
    length: 'SSN must contain exactly 9 digits.',
    format: 'SSN must be entered as 123-45-6789 or 123456789.',
    area: 'SSN cannot begin with 000, 666, or 900-999.',
    group: 'The middle two digits of the SSN cannot be 00.',
    serial: 'The last four digits of the SSN cannot be 0000.'
};

export function isMaskedSsn(ssn: string): boolean {
    return !!ssn && ssn.includes('*');
}

export function getSsnValidationError(ssn: string): string | null {
    const value = (ssn ?? '').trim();

    if (!value) {
        return SSN_ERROR_MESSAGES.length;
    }

    if (!ALLOWED_CHARACTERS.test(value)) {
        return SSN_ERROR_MESSAGES.characters;
    }

    const digits = value.replace(/\D/g, '');

    if (digits.length !== REQUIRED_LENGTH) {
        return SSN_ERROR_MESSAGES.length;
    }

    if (!SUPPORTED_FORMAT.test(value)) {
        return SSN_ERROR_MESSAGES.format;
    }

    const area = digits.slice(0, 3);

    if (area === '000' || area === '666' || area.startsWith('9')) {
        return SSN_ERROR_MESSAGES.area;
    }

    if (digits.slice(3, 5) === '00') {
        return SSN_ERROR_MESSAGES.group;
    }

    if (digits.slice(5) === '0000') {
        return SSN_ERROR_MESSAGES.serial;
    }

    return null;
}

export function formatSsn(ssn: string): string {
    const digits = (ssn ?? '').replace(/\D/g, '');

    return digits.length === REQUIRED_LENGTH
        ? `${digits.slice(0, 3)}-${digits.slice(3, 5)}-${digits.slice(5)}`
        : ssn;
}
